<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/order"
                saveRoot="/order"
                @onInit="onInit"
                @onInitSuccess="onInitSuccess"
                @onSaveSuccess="onSaveSuccess"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.order">
            <slot slot="beforeFormButtons">
                <b-button v-if="Core.Validation.isId(dataId)" @click="modelInvoiceOnClick" class="btn btn-light mr-2"><i class="fa fa-file-text mr-2"></i>{{Core.Definition.getDefinition('Facture')}}</b-button>
                <ModalInvoice ref="modalInvoice"></ModalInvoice>
            </slot>
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/order"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la commande')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette commande?')"></ModalTrash>
    </div>
</template>

<script>
    var _self = null
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import ModalInvoice from '../../components/ModalInvoice'
    export default {
        name: 'Order',
        components: {
            DynamicForm,
            ModalTrash,
            ModalInvoice
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    order: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: window.Core.Definition.getDefinition('Commande'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'creationDate'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Client'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'userAction'
                                                                    },
                                                                    {
                                                                        id: 'userId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingFirstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingLastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingEmail'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingPhone'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'productStandardSummary'
                                            }
                                        ]
                                    },
                                    {}
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'payments'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'creationDate',
                                type: 'date',
                                label: Core.Definition.getDefinition('Date de création'),
                                value: Core.Date.getToday()
                            },
                            {
                                id: 'billingFirstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'billingLastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'billingEmail',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'billingPhone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label: 'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'notes',
                                type: 'notes',
                                options: [{
                                                label: Core.Definition.getDefinition('Normal'),
                                                value: 'normal'
                                            },
                                            {
                                                    label: Core.Definition.getDefinition('Privé'),
                                                    value: 'private'
                                            }]
                            },
                            {
                                id: 'payments',
                                type: 'payments',
                                total: 0,
                                forceTotal: false,
                                onTokenizationSuccess(payment) {
                                    _self.$refs.dynamicForm.addSaveArg('payment', JSON.stringify(payment))
                                    _self.$refs.dynamicForm.$refs.form.submit()
                                },
                                onPaymentCompleted(payment) {
                                    if (payment.method !== undefined) {
                                        switch(payment.method) {
                                            case Core.Payment.methodTerminal:
                                            case Core.Payment.methodCash:
                                                _self.$refs.dynamicForm.$refs.form.submit()
                                                break
                                        }
                                    }
                                },
                                onCheckPayment(){}
                            },
                            {
                                id: 'productStandardSummary',
                                type: 'productStandardSummary',
                                required: true,
                                value: [],
                                updateTotal: function(subTotal, total, form, fieldRefs, productSummaryProducts) {
                                    fieldRefs['payments'].subTotal = subTotal
                                    fieldRefs['payments'].total = total
                                }
                            },
                            {
                                id: 'userId',
                                type: 'hidden',
                                value: ''
                            },
                            {
                                id: 'userAction',
                                type: 'userAction',
                                class: 'mb-3 pull-right',
                                updateUser: function(value, form, fieldRefs) {
                                    if (value.id === undefined) {
                                        value.id = ''
                                    }
                                    fieldRefs['userId'].dataValue = value.id

                                    fieldRefs['payments'].userId = value.id

                                    if (value.firstname === undefined) {
                                        value.firstname = ''
                                    }
                                    fieldRefs['billingFirstname'].dataValue = value.firstname

                                    if (value.lastname === undefined) {
                                        value.lastname = ''
                                    }
                                    fieldRefs['billingLastname'].dataValue = value.lastname

                                    if (value.email === undefined) {
                                        value.email = ''
                                    }
                                    fieldRefs['billingEmail'].dataValue = value.email

                                    if (value.phone === undefined) {
                                        value.phone = ''
                                    }
                                    fieldRefs['billingPhone'].dataValue = value.phone

                                    if (value.billingAddress === undefined) {
                                        value.billingAddress = ''
                                    }
                                    fieldRefs['billingAddress'].dataValue = value.billingAddress

                                    if (value.billingCountry === undefined) {
                                        value.billingCountry = 'CA'
                                    }
                                    fieldRefs['billingCountry'].dataValue = window.Core.Select.select(value.billingCountry, fieldRefs['billingCountry'].getOptions())

                                    if (value.billingCity === undefined) {
                                        value.billingCity = ''
                                    }
                                    fieldRefs['billingCity'].dataValue = value.billingCity

                                    if (value.billingZipcode === undefined) {
                                        value.billingZipcode = ''
                                    }
                                    fieldRefs['billingZipcode'].dataValue = value.billingZipcode

                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInit(data) {
                if (Core.Validation.isId(this.$route.params.userId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initUserId', this.$route.params.userId)
                }
                if (Core.Validation.isId(this.$route.params.productId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initProductId', this.$route.params.productId)
                }
            },
            onInitSuccess(data) {
                if (data.form !== undefined && data.form.userId !== undefined) {
                    this.$refs.dynamicForm.$refs.form.fieldRefs['payments'].userId = data.form.userId
                }
                if (data.form !== undefined && data.form.billingEmail !== undefined) {
                    this.$refs.modalInvoice.email = data.form.billingEmail
                }
                if (data.selectOptions !== undefined) {
                    if(data.selectOptions.teamId !== undefined) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['productStandardSummary'].$refs.productSummary.teamId = data.selectOptions.teamId
                    }
                    if(data.selectOptions.participantCategoryId !== undefined) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['productStandardSummary'].$refs.productSummary.participantCategoryId = data.selectOptions.participantCategoryId
                    }
                    if(data.selectOptions.tshirtSize !== undefined) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['productStandardSummary'].$refs.productSummary.tshirtSize = data.selectOptions.tshirtSize
                    }
                    if(data.selectOptions.seasonId !== undefined) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['productStandardSummary'].$refs.productSummary.seasonId = data.selectOptions.seasonId
                    }
                    if(data.selectOptions.districtId !== undefined) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['productStandardSummary'].$refs.productSummary.districtId = data.selectOptions.districtId
                    }
                    if(data.selectOptions.leagueId !== undefined) {
                        this.$refs.dynamicForm.$refs.form.fieldRefs['productStandardSummary'].$refs.productSummary.leagueId = data.selectOptions.leagueId
                    }
                }
            },
            onSaveSuccess() {
                this.$refs.dynamicForm.$refs.request.clearArgs()
                this.$refs.dynamicForm.clearSaveArgs()
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/commerce/commandes')
            },
            modelInvoiceOnClick() {
                this.$refs.modalInvoice.instanceType = 'order'
                this.$refs.modalInvoice.instanceId = this.dataId
                this.$refs.modalInvoice.open = true
            }
        }
    }
</script>
